import React from 'react';
import { BaseStepProps } from './BaseStep';

// Startup step components
import StartupCompanyStep from './startup/CompanyStep';
import StartupIndustryStep from './startup/IndustryStep';
import StartupFoundersStep from './startup/FoundersStep';
import StartupOwnershipStep from './startup/OwnershipStep';
import StartupExternalSupportStep from './startup/ExternalSupportStep';
import StartupMatchingStartsStep from './startup/MatchingStartsStep';

// Investor step components
import InvestorCompanyStep from './investor/CompanyStep';
import InvestorIndustryStep from './investor/IndustryStep';
import InvestorFoundersStep from './investor/FoundersStep';
import InvestorOwnershipStep from './investor/OwnershipStep';
import InvestorExternalSupportStep from './investor/ExternalSupportStep';
import InvestorMatchingStartsStep from './investor/MatchingStartsStep';

// Define the step factory type
export type StepFactory = {
  [key: string]: React.ComponentType<BaseStepProps>;
};

// Startup step factory - maps step IDs to startup components
const startupStepFactory: StepFactory = {
  company: StartupCompanyStep,
  'industry-stage': StartupIndustryStep,
  'founders-team': StartupFoundersStep,
  'ownership-traction': StartupOwnershipStep,
  'external-support': StartupExternalSupportStep,
  'matching-starts': StartupMatchingStartsStep,
};

// Investor step factory - maps step IDs to investor components
const investorStepFactory: StepFactory = {
  company: InvestorCompanyStep,
  'industry-stage': InvestorIndustryStep,
  'founders-team': InvestorFoundersStep,
  'ownership-traction': InvestorOwnershipStep,
  'external-support': InvestorExternalSupportStep,
  'matching-starts': InvestorMatchingStartsStep,
};

// Function to get a step component by ID and userType
export const getStepComponent = (
  stepId: string,
  userType: 'startup' | 'investor'
): React.ComponentType<BaseStepProps> | null => {
  const factory = userType === 'startup' ? startupStepFactory : investorStepFactory;
  return factory[stepId] || null;
};

// Function to check if a step exists
export const stepExists = (stepId: string, userType: 'startup' | 'investor'): boolean => {
  const factory = userType === 'startup' ? startupStepFactory : investorStepFactory;
  return stepId in factory;
};

// Export all step components for direct imports if needed
export { BaseStep, FormField, useFormData } from './BaseStep';
export type { BaseStepProps, FormFieldProps } from './BaseStep';
